<template>
  <div class="rapport-lans-container mb-3">
    <v-textarea
      auto-grow
      rows="1"
      outlined
      label="Eventuell engelsk originaltitel"
      v-model="englishTitle"
      hide-details="auto"
    ></v-textarea>
    <v-expansion-panels>
      <slot name="image"></slot>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Information </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            outlined
            label="Utgivare"
            messages="Du kan ange flera"
            v-model="publisher"
          ></v-text-field>
          <div class="flex mt-5">
            <v-text-field outlined label="Publiceringsår" v-model="year"></v-text-field>
            <v-text-field outlined label="Rapport-id" v-model="reportId"></v-text-field>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Länkar </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-text-field
              outlined
              label="Länk till fil"
              messages="https://www...."
              placeholder="https://... "
              v-model="link"
              class="mb-2"
              :loading="!!uploadFile"
            ></v-text-field>
            <Upload @add="onAddFile" container="dokument" class="my-3 mb-5">
              <div class="upload-container">
                <v-progress-circular
                  v-if="uploadFile"
                  :rotate="360"
                  :size="40"
                  :width="3"
                  :value="uploadFile.progress"
                  color="primary"
                >
                  <span class="caption">{{ `${uploadFile.progress}%` }}</span>
                </v-progress-circular>
                <template v-else>
                  <v-icon large color="#ececec">mdi-cloud-upload-outline</v-icon>
                  <h5>Klicka eller dra fil hit för att lägga till rapport</h5>
                </template>
              </div>
            </Upload>
            <v-divider class="my-5"></v-divider>

            <v-text-field
              outlined
              label="Länk original källa"
              placeholder="https://... "
              v-model="originalSourceLink"
              class="mb-2"
            ></v-text-field>
            <v-text-field
              outlined
              label="Länk populärvetenskap"
              messages="Länk till ev. populärvetenskaplig presentation"
              v-model="popLink"
              class="mb-2"
            ></v-text-field>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="overline"> Nyckelord </v-expansion-panel-header>
        <v-expansion-panel-content> <slot name="keywords"></slot> </v-expansion-panel-content
      ></v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Upload from '@/components/shared/Upload.vue'

export default {
  name: 'ReportLansstyrelse',
  props: {
    article_title_original: { type: String },
    article_name: { type: String },
    article_reportid: { type: String },
    article_year: { type: String },
    article_originalsource: { type: String },
    article_reference_pop: { type: String },
    article_file: { type: String },
  },
  components: {
    Upload,
  },
  data() {
    return {
      uploadFile: null,
    }
  },
  computed: {
    englishTitle: {
      get() {
        return this.article_title_original
      },
      set(val) {
        this.$emit('update', { article_title_original: val })
      },
    },

    reportId: {
      get() {
        return this.article_reportid
      },
      set(val) {
        this.$emit('update', { article_reportid: val })
      },
    },
    year: {
      get() {
        return this.article_year
      },
      set(val) {
        this.$emit('update', { article_year: val })
      },
    },
    link: {
      get() {
        return this.article_file
      },
      set(val) {
        this.$emit('update', { article_file: val })
      },
    },
    publisher: {
      get() {
        return this.article_name
      },
      set(val) {
        this.$emit('update', { article_name: val })
      },
    },
    originalSourceLink: {
      get() {
        return this.article_originalsource
      },
      set(val) {
        this.$emit('update', { article_originalsource: val })
      },
    },
    popLink: {
      get() {
        return this.article_reference_pop
      },
      set(val) {
        this.$emit('update', { article_reference_pop: val })
      },
    },
  },
  methods: {
    async onAddFile({ azureFile }) {
      this.uploadFile = azureFile 
      const { status, url } = await this.uploadFile.send()
      if (status === 201) {
        this.$emit('updateImmediately', { article_file: url })
      } else {
        // eslint-disable-next-line no-alert
        alert('Problem uppstod när filen skulle laddas upp')
      }
      this.uploadFile = null
    },
  },
}
</script>

<style lang="less" scoped>
.rapport-lans-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  .flex {
    display: flex;
    gap: 15px;
  }
  .upload-container {
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
